
import { AxiosHelper } from '../helpers/AxiosHelper';


const List = async (formData: FormData) => {
    return AxiosHelper.post('/ServiceOrderLog/List', formData);
}


const GetStatisticalLog = async (formData: FormData) => {
    return AxiosHelper.post('/ServiceOrderLog/GetStatisticalLog', formData);
}


const ServiceOrderLogService = {
    List,
    GetStatisticalLog
}

export default ServiceOrderLogService;